import { createFetchReducer } from '@copilot/common/store/reducers/fetch';
import { ATTENTION_ITEMS } from './constant';

export const attentionItemsReducer = createFetchReducer(ATTENTION_ITEMS);
